<template>
  <div class="campManage">
    <div class="breadcrumb">
      院系管理
      <el-button class="right_f" type="primary" @click="adddepartment"
        >新增院系</el-button
      >
      <el-upload
        class="uploadBtn_camp right_f"
        v-if="region"
        :with-credentials="true"
        :action="importdepartment"
        :headers="headers"
        :on-success="handleSuccess"
        :on-error="handleError"
        name="uploadFile"
        show-file-list="false"
      >
        <el-button type="primary">导入院系及班级</el-button>
      </el-upload>
      <el-button
        class="right_f"
        type="primary"
        @click="exportDepAndClass"
        v-if="region"
        >导出院系及班级</el-button
      >
      <el-button class="right_f" type="primary" @click="exportModel"
        >导出模板</el-button
      >
    </div>

    <div
      style="
        font-size: 14px;
        color: red;
        margin-left: 15px;
        line-height: 28px;
        margin-bottom: 20px;
      "
    >
      <p>提示:</p>
      <p>
        1,只有弹出导入成功提示框才表示导入成功，如果长时间不能导入成功，请刷新页面重新导入
      </p>
    </div>

    <div class="selectSchool">
      <el-select
        class="selectInput"
        v-model="region"
        filterable
        clearable
        placeholder="请输入高校名称"
        @change="getdepartment"
      >
        <el-option
          v-for="item in options"
          :value="item.rootUnid"
          :label="item.name"
          :key="item.name"
        >
        </el-option>
      </el-select>
    </div>

    <div class="com-list">
      <el-table :data="department" style="width: 100%">
        <el-table-column type="index" prop="index" label="序号" width="80">
        </el-table-column>
        <el-table-column prop="department" label="院系名称" width="250">
        </el-table-column>
        <el-table-column label="班级名称" inline-template>
          <span v-for="item in row.classList" class="classItem">{{
            item.className
          }}</span>
        </el-table-column>
        <el-table-column inline-template label="操作">
          <div>
            <el-button
              type="text"
              size="small"
              @click="editdepartment($index, row)"
              >编辑院系名称</el-button
            >
            <el-button type="text" size="small" @click="editclass(row)"
              >编辑班级</el-button
            >
            <el-button
              type="text"
              size="small"
              @click="deletedepartment($index, row)"
              >删除</el-button
            >
          </div>
        </el-table-column>
      </el-table>
    </div>

    <el-dialog
      title="新增院系"
      v-model="adddepartmentVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="addForm" :rules="addRules" ref="addForm">
        <el-form-item
          label="院系名称"
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-input
            type="text"
            v-model="addForm.name"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          @click="adddepartmentsubmit"
          id="submit"
          :disabled="disabled"
          >保存</el-button
        >
      </div>
    </el-dialog>

    <el-dialog
      title="编辑院系"
      v-model="editdepartmentVisible"
      :modal-append-to-body="false"
    >
      <el-form :model="editForm" ref="editForm">
        <el-form-item
          label="院系名称"
          prop="name"
          :label-width="formLabelWidth"
        >
          <div>{{ this.editdepartname }}</div>
        </el-form-item>
        <el-form-item
          label="院系名称"
          prop="name"
          :label-width="formLabelWidth"
        >
          <el-input
            type="text"
            placeholder="请输入院系名称"
            v-model="editForm.departmentname"
            auto-complete="off"
          >
          </el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="editdepartmentsubmit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog
      title="删除院系"
      v-model="deletedepartmentVisible"
      :modal-append-to-body="false"
    >
      <p>确定删除此院系吗？</p>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deletedepartmentsubmit"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    let checkName = (rule, value, callback) => {
      if (value) {
        if (value.trim()) {
          callback();
        } else {
          callback(new Error("院系名称不能为空"));
        }
      } else {
        callback(new Error("请输入院系名称"));
      }
    };

    return {
      region: "",
      option: [],
      schoolLists: [],
      camps: [],
      addFormVisible: false,
      disabled: false,
      headers: {
        rootUnid: "",
      },
      addForm: {
        name: "",
        status: "签约",
        isOpenness: "是",
      },
      addRules: {
        name: [
          { required: true, message: "请输入院系名称", trigger: "blur" },
          {
            min: 1,
            max: 20,
            message: "院系名称不可超过20个字符",
            trigger: "blur",
          },
          { validator: checkName },
        ],
        status: [
          { required: true, message: "请选择合作状态", trigger: "change" },
        ],
        isOpenness: [
          {
            required: true,
            message: "请选择是否开放性注册",
            trigger: "change",
          },
        ],
      },
      editForm: {
        name: "",
        status: "",
        isOpenness: "",
        departmentname: "",
      },
      editIndex: "",
      editFormVisible: false,
      formLabelWidth: "100px",
      options: [],
      adddepartmentVisible: false,
      department: [],
      editdepartmentVisible: false,
      rowstate: "",
      deletedepartmentVisible: false,
      index: "",
      importdepartment: "",
      editdepartname: "",
    };
  },
  mounted() {
    this.getschoolandunid();
    this.region = this.$util.getUrlParam("unid");
    if (this.region) {
      this.getdepartment();
    }
  },
  computed: {
    importdepartment() {
      return (
        this.$util.domain + "/adminapi/v1/campus/department/importDepartment"
      );
    },
  },
  methods: {
    //获取所有学校
    getschoolandunid() {
      this.$http({
        method: "get",
        url: this.$util.domain + "/adminapi/v1/basicTools/allSchools",
      }).then((response) => {
        if (response.data.error == 10000) {
          this.options = response.body.data; //给option数组赋值，这里要在下拉列表里面展示出来
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //根据学校获取院系
    getdepartment() {
      let url =
        this.$util.domain +
        "/adminapi/v2/campus/department/allDepartmentClass?unid=" +
        this.region;
      this.$http({
        url,
        method: "POST",
        headers: {
          rootUnid: this.region + "",
        },
      }).then((response) => {
        this.department = response.data.data;
        this.headers.rootUnid = this.region + "";
      });
    },
    adddepartment() {
      if (!this.region) {
        this.$util.errorMsg("请先选择一个有效校区");
      } else {
        this.adddepartmentVisible = true;
      }
    },
    adddepartmentsubmit() {
      this.disabled = true; //禁用保存按钮；
      setTimeout(() => {
        this.disabled = false;
      }, 3000);
      this.$refs.addForm.validate((valid) => {
        if (valid) {
          this.$http({
            method: "post",
            url:
              this.$util.domain +
              "/adminapi/v1/campus/department/addDepartment",
            body: JSON.stringify({
              rootUnid: this.region,
              department: this.addForm.name.trim(),
            }),
          }).then((response) => {
            if (response.data.error == 10000) {
              this.$util.successMsg("新增院系成功");
              this.adddepartmentVisible = false; //要即时添加数据，那么后台要即时返回
              this.getdepartment();
              this.addForm.name = ""; //清空输入框
            } else {
              this.$util.errorMsg(response.data.message);
            }
          });
        } else {
          console.log("error submit");
        }
      });
    },
    //编辑院系
    editdepartment($index, row) {
      this.editdepartname = row.department;
      this.editdepartmentVisible = true;
      this.rowstate = row;
    },
    //编辑班级
    editclass(row) {
      location.href = `/#/xiaoyuan/GX/classManage?departid=${row.id}&rootUnid=${
        this.region
      }&departName=${encodeURI(row.department)}`;
    },
    trim(string) {
      return string.replace(/(^\s*)|(\s*$)/g, "");
    },
    editdepartmentsubmit() {
      if (this.trim(this.editForm.departmentname) == "") {
        this.$util.errorMsg("请输入院系名字");
        return false;
      }
      let url = `${this.$util.domain}/adminapi/v1/campus/department/editDepartment`;
      this.$http({
        //id院系id，rootunid学校根id，department院系名字
        url,
        method: "POST",
        body: JSON.stringify({
          id: this.rowstate.id,
          rootUnid: this.region,
          department: this.editForm.departmentname.trim(),
        }),
      }).then((response) => {
        if (response.data.error == 10000) {
          this.$util.successMsg("修改成功");
          this.editdepartmentVisible = false;
          this.rowstate.department = this.editForm.departmentname;
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //删除院系
    deletedepartment($index, row) {
      this.deletedepartmentVisible = true;
      this.rowstate = row;
      this.index = $index;
    },
    deletedepartmentsubmit() {
      this.$http({
        method: "post",
        url:
          this.$util.domain + "/adminapi/v1/campus/department/deleteDepartment",
        body: JSON.stringify({
          id: this.rowstate.id,
          rootUnid: this.region,
          department: this.rowstate.department,
        }),
      }).then((response) => {
        if (response.data.error == 10000) {
          this.$util.successMsg("删除成功");
          this.deletedepartmentVisible = false;
          this.department.splice(this.index, 1);
        } else {
          this.$util.errorMsg(response.data.message);
        }
      });
    },
    //导入成功
    handleSuccess(response) {
      if (response.error == 10000) {
        this.getdepartment();
        this.$util.successMsg("导入成功");
      } else {
        this.$util.errorMsg(response.message);
      }
    },
    //导入失败
    handleError(response) {
      this.$util.errorMsg(response.message);
    },
    //导出院系级班级
    exportDepAndClass() {
      location.href = `${this.$util.domain}/adminapi/v1/campus/department/exportDepartClass?rootUnid=${this.region}`;
    },
    //导出模板
    exportModel() {
      location.href =
        "https://admin.gxapp.iydsj.com/template/department_class.xlsx";
    },
  },
};
</script>
<style>
.uploadBtn_camp {
  display: inline-block;
  width: 130px;
  text-align: center;
  text-indent: 0;
}

.el-upload__files {
  display: none;
}

.classItem {
  display: inline-block;
  margin-right: 10px;
}
</style>



// WEBPACK FOOTER //
// departmentManage.vue?18a71978